
















































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import Pagination from "@/components/paginaiton.vue";
import {
  DeleteTongue,
  GetHospitals,
  GetTonguePicLists,
  DeleteSomeTongues,
  GetTongueTemplates,
  GetTongueTopicsOfTemplate,
} from "@/request/tongue";
import PicList from "./picList.vue";
import TextList from "./textList.vue";
@Component({
  components: {
    Pagination,
    PicList,
    TextList,
  },
})
export default class BiduiList extends Vue {
  private ifShowBiaozhu: boolean = false;
  private listType: any = "pic";
  private filters: any = {
    hospital_ids: [],
    范围: [],
    姓名: "",
    性别: "",
    开始时间: "",
    结束时间: "",
    年龄段: [],
    timeWay: "",
    time: [],
    条件: "",
    研究指标: [],
    自定义年龄: [false],
    时间段: "",
    自定义时间段: [false, []],
  };
  private hospitals: any[] = [];
  private currentPage: number = 1;
  private orderField: string = "创建时间";
  private orderValue: any = 0;
  private pageCount: any = 12;
  private primaryFilters: any = {};
  private totalCount: any = 0;
  private tongues: any[] = [];
  // 高级筛选
  private ifShowPrimarySearch: boolean = false;
  private searchedTemplates: any[] = [];
  private ifPrimarySearched: boolean = false;
  // 选择舌图
  private selectedTongues: any[] = [];
  /**
   * @description 跳转智能标注
   */
  private jumpBiaozhu() {
    this.$router.push("/main/tongue/tongue-list");
  }
  /**
   * @description 取消选择的舌图
   */
  private cancelSelectedTongue(tongue) {
    const index = _.findIndex(this.selectedTongues, (i) => {
      return i.tongue_id === tongue.tongue_id;
    });
    if (index !== -1) {
      this.selectedTongues.splice(index, 1);
      localStorage.setItem(
        "selectedTongues",
        JSON.stringify(this.selectedTongues)
      );
      this.tongues.forEach((t: any) => {
        const j = _.findIndex(this.selectedTongues, (i) => {
          return i.tongue_id === t.tongue_id;
        });
        if (j === -1) {
          t.selected = false;
        } else {
          t.selected = true;
        }
      });
    }
  }
  /**
   * @description 开始比对
   */
  private startBidui() {
    // console.log(this.selectedTongues);
    if (this.selectedTongues.length <= 1) {
      this.$message.warning("请至少选择两张舌图");
      return;
    }
    localStorage.setItem(
      "selectedTongues",
      JSON.stringify(this.selectedTongues)
    );
    this.$router.push({
      path: "/main/tongue/bidui-result",
    });
  }
  /**
   * @description 改变列表展示的形式
   */
  private changeListType(type) {
    this.listType = type;
  }
  /**
   * @description 获得可选医院列表
   */
  private fetchHospitals() {
    GetHospitals(this).then((data: any) => {
      this.hospitals = data;
      this.hospitals.unshift({ hospital_id: "", 医院名称: "全部医院" });
    });
  }
  /**
   * @description 改变排序顺序
   */
  private changeOrderValue() {
    this.orderValue = this.orderValue === 0 ? 1 : 0;
    this.search();
  }
  /**
   * @description 获得舌图图片列表
   */
  private fetchTongueList() {
    // hospital_ids
    this.filters.hospital_ids = [];
    this.filters["范围"].forEach((item: any) => {
      this.filters.hospital_ids.push(item);
    });
    if (this.filters.hospital_ids.includes("")) {
      this.filters.hospital_ids = [];
    }
    const params = _.cloneDeep(this.filters);
    params["current_page"] = this.currentPage;
    params["order_field"] = this.orderField;
    params["order_value"] = this.orderValue;
    params["page_count"] = this.pageCount;
    params["条件"] = this.filters["条件"];
    // 时间段
    if (this.filters.timeWay === "自定义") {
      params["开始时间"] = this.filters.time[0];
      params["结束时间"] = this.filters.time[1];
      this.ifPrimarySearched = true;
    }
    if (this.filters["研究指标"].length > 0) {
      this.ifPrimarySearched = true;
      const arr: any[] = [];
      this.filters["研究指标"].map((item: any) => {
        const i = JSON.parse(JSON.stringify(item.selected));
        i.condition = item.result.condition;
        i.value = item.result.value;
        arr.push(i);
      });
      params["研究指标"] = arr;
    }
    GetTonguePicLists(this, params).then((data: any) => {
      // console.log(data);
      data.tongues.forEach((tongue: any) => {
        const index = _.findIndex(this.selectedTongues, (i) => {
          return i.tongue_id === tongue.tongue_id;
        });
        if (index === -1) {
          tongue.selected = false;
        } else {
          tongue.selected = true;
        }
      });
      this.$set(this, "tongues", data.tongues);

      this.totalCount = data.total_count;
    });
  }
  /**
   * @description 搜索
   */
  private search() {
    this.currentPage = 1;
    this.fetchTongueList();
  }
  /**
   * @description 打开高级筛选
   */
  private openPrimarySearch() {
    this.fetchTemplates();
    this.ifShowPrimarySearch = true;
  }
  /**
   * @description 处理高级筛选
   */
  private primaryFilterChange(val) {
    this.ifShowPrimarySearch = false;
    this.$set(this, "filters", val);
    this.currentPage = 1;
    this.ifPrimarySearched = true;
    this.fetchTongueList();
  }
  /**
   * @description 添加研究指标变量
   */
  private addTiaojian() {
    this.filters["研究指标"].push({ result: {}, selected: {} });
  }
  /**
   * @description 获取当前分组下的可选模板列表
   */
  private fetchTemplates() {
    GetTongueTemplates(this).then((data: any) => {
      this.searchedTemplates = data;
    });
  }
  /**
   * @description 搜索模板下具体的字段
   */
  private searchItems(l) {
    GetTongueTopicsOfTemplate(this, l.template_id).then((data: any) => {
      l.items = data;
      this.$forceUpdate();
    });
  }
  /**
   * @description 删除一个条件
   */
  private deleteTiaojian(index: any) {
    this.filters["研究指标"].splice(index, 1);
  }
  /**
   * @description 重置高级筛选条件
   */
  private resetPrimarySearch() {
    this.ifPrimarySearched = false;
    this.currentPage = 1;
    this.$set(this, "filters", {
      hospital_ids: [],
      范围: [],
      姓名: "",
      性别: "",
      开始时间: "",
      结束时间: "",
      年龄段: [],
      timeWay: "",
      time: [],
      条件: "",
      研究指标: [],
      自定义年龄: [false],
      时间段: "",
      自定义时间段: [false, []],
    });
    this.fetchTongueList();
  }
  /**
   * @description 取消高级筛选
   */
  private cancelPrimarySearch() {
    this.ifShowPrimarySearch = false;
  }
  /**
   * @description 确定高级筛选
   */
  private confirmPrimarySearch() {
    this.ifShowPrimarySearch = false;
    this.currentPage = 1;
    this.ifPrimarySearched = true;
    this.fetchTongueList();
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val) {
    this.currentPage = val;
    this.fetchTongueList();
  }
  /**
   * @description 切换一个舌图的选中状态
   */
  private triggerOneTongue(tongue) {
    tongue.selected = !tongue.selected;
    const index = _.findIndex(this.selectedTongues, (i) => {
      return i.tongue_id === tongue.tongue_id;
    });
    if (tongue.selected) {
      if (index === -1) {
        this.selectedTongues.push(tongue);
        localStorage.setItem(
          "selectedTongues",
          JSON.stringify(this.selectedTongues)
        );
      }
    } else {
      if (index !== -1) {
        this.selectedTongues.splice(index, 1);
        localStorage.setItem(
          "selectedTongues",
          JSON.stringify(this.selectedTongues)
        );
      }
    }
  }
  /**
   * @description 全选
   */
  private selectAll() {
    this.tongues.forEach((tongue: any) => {
      if (!tongue.selected) {
        const index = _.findIndex(this.selectedTongues, (i) => {
          return i.tongue_id === tongue.tongue_id;
        });
        if (index === -1) {
          tongue.selected = true;
          this.selectedTongues.push(tongue);
          localStorage.setItem(
            "selectedTongues",
            JSON.stringify(this.selectedTongues)
          );
        }
      }
    });
  }
  /**
   * @description 全不选
   */
  private cancelSelectAll() {
    this.tongues.forEach((tongue: any) => {
      if (tongue.selected) {
        const index = _.findIndex(this.selectedTongues, (i) => {
          return i.tongue_id === tongue.tongue_id;
        });
        if (index !== -1) {
          tongue.selected = false;
          this.selectedTongues.splice(index, 1);
          localStorage.setItem(
            "selectedTongues",
            JSON.stringify(this.selectedTongues)
          );
        }
      }
    });
  }

  /**
   * @description 初始化
   */
  private mounted() {
    const arr = localStorage.getItem("selectedTongues");
    if (arr) {
      this.selectedTongues = JSON.parse(arr);
    }
    this.fetchHospitals();
    this.fetchTongueList();
  }
}
